import { render, staticRenderFns } from "./AppSecondScreen.vue?vue&type=template&id=43f2b354&scoped=true"
import script from "./AppSecondScreen.vue?vue&type=script&lang=js"
export * from "./AppSecondScreen.vue?vue&type=script&lang=js"
import style0 from "./AppSecondScreen.vue?vue&type=style&index=0&id=43f2b354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f2b354",
  null
  
)

export default component.exports